import React from "react";
import Header from "../Homepage/Header";
import Hero from "../Homepage/Hero";

function Profile() {
  return <Header />;
}

export default Profile;
